
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-it-works",
      function () {
        return require("private-next-pages/how-it-works.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-it-works"])
      });
    }
  